import React, { FC } from "react"
import { navigate } from "gatsby"

// Shared components
import AnchorLink from "@components/AnchorLink/AnchorLink"
import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"
import Tabs from "@components/Tabs/Tabs"

// Utils
import { logCustomGAEvent } from "../../_utils"
import { GA_CUSTOM_EVENTS } from "../../_store/constants"

// Styled components
import { InterviewBuilderHeroHERO } from "./InterviewBuilderHero.styles"

type InterviewBuilderHeroProps = {
  activeTab: string
  backLink?: string | (() => void)
  isContentPage?: boolean
}

const InterviewBuilderHero: FC<InterviewBuilderHeroProps> = ({
  activeTab,
  backLink,
  isContentPage,
}) => {
  return (
    <InterviewBuilderHeroHERO
      className={isContentPage ? "is-content-page background-color--cobalt-100" : "background-color--cobalt-100"}
    >
      <div className="container">
        <div className="grid">
          <div className="hero-content column column--2-12-S column--3-11-XL">
            <div className="font-size--M">
              <h1>Customer Service</h1>
              <h1>Interview Builder</h1>
            </div>
            <div className="margin-top--S margin-bottom--S spacing--L">
              <p>
                Level up your next hiring round by selecting from our targeted customer
                service questions, editing and ordering them, and downloading them as a PDF.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="grid">
          <div className="column">
            {backLink &&
              (typeof backLink === "string" ? (
                <AnchorLink
                  href={backLink}
                  className="back-link"
                  aria-label="Go back to the previous view"
                >
                  <Icon size="24px" type={ICON_TYPES["arrow-left"]} />
                </AnchorLink>
              ) : (
                <button className="back-link" onClick={backLink}>
                  <Icon size="24px" type={ICON_TYPES["arrow-left"]} />
                </button>
              ))}
            <Tabs
              activeOption={activeTab}
              onClickOption={(pathname) => {
                logCustomGAEvent(GA_CUSTOM_EVENTS.SELECT_HERO_TAB, {
                  path: pathname as string,
                })
                window.location.pathname !== (pathname as string)
                  ? navigate(pathname as string)
                  : null
              }}
              options={[
                {
                  title: "Interview Builder",
                  value: `/interview-builder/`,
                },
                {
                  title: "Selected Questions",
                  value: `/interview-builder/selected-questions/`,
                },
                {
                  mobileTitle: "Library",
                  title: "Job Description Library",
                  value: `/interview-builder/library/`,
                },
                {
                  mobileTitle: "Guide",
                  title: "Interviewing Guide",
                  value: `/interview-builder/guide/`,
                },
              ]}
            />
          </div>
        </div>
      </div>
    </InterviewBuilderHeroHERO>
  )
}

export default InterviewBuilderHero
